import { inject, injectable } from "inversify";
import AbstractConnect from "../../../../framework/src/connect/ajax/AbstractConnect";
import IConnectControl from "../../../../framework/src/connect/controllers/IConnectControl";
import FetchAjax from "../../../../framework/src/connect/FetchAjax";
import SERVICE_IDENTIFIER from "../../../../framework/src/constants/identifiers";
import SystemConfig, {
	CONFIG_PARAMS,
} from "../../../../framework/src/system/SystemConfig";
import IDOM from "../../../../framework/src/ui/IDOM";
import { parseURL } from "../../../../framework/src/connect/Connect";
import { IColorTheme } from "../interfaces/IColorScheme";

@injectable()
export class JokerWinThemes extends AbstractConnect {
	fetchType: string = "JokerWinThemes";
	groupId: number;
	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
		@inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
		@inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
	) {
		super(config, control, fetch, dom);
		this.timeout = 3000;
		this.setMethod(
			this.config.get(CONFIG_PARAMS.URL_JOKER_BONUS_THEMES_METHOD)
		);
	}
	async fetch(): Promise<IColorTheme> {
		this.control.reset();

		return (await this._fetch()).data;
	}
	protected getParams(): Record<string, any> {
		return {};
	}
	protected getUrl(): string {
		return parseURL(this.config.get(CONFIG_PARAMS.URL_JOKER_BONUS_THEMES), {
			group_id: this.groupId,
		});
	}
}
